<template>
  <div id="LayIntarTranslateZh">
    <div class="LayIntarTranslateZh">
      <div class="transHeader">
        <el-select v-model="connect.from_lang" filterable placeholder="请选择">
          <el-option
              v-for="item in langNewArr"
              :key="item.alis"
              :label="item.name_lang.zh||item.name_lang.mn"
              :value="item.alis">
          </el-option>
        </el-select>
        <p class="ibox">
          <i @click="Hh" class="iconfont iconfangxianglei-huhuan"></i>
        </p>
        <el-select v-model="connect.to_lang" filterable placeholder="请选择">
          <el-option
              v-for="item in langNewArr"
              :key="item.alis"
              :label="item.name_lang.zh||item.name_lang.mn"
              :value="item.alis">
          </el-option>
        </el-select>
      </div>
      <div class="translation-box">
        <div class="grid-content">
          <div class="translate_box" :class="connect.from_lang=='mn'?'aqt_lang_mn':''">
          <textarea ref="textareaContent" :class="connect.from_lang=='mn'?'titlefont':''"
                    class="textarea_1_up"
                    v-model="connect.from" @input="maxLengthinput" @blur="maxLengthblur"
                    :placeholder="connect.from_lang=='mn'?$t('m.please_input_translation'):'请输入文本'|U2M"></textarea>

          </div>
          <div class="translate_copy">
            <p>
              <Tooltip v-if="connect.from" content="翻译" placement="top">
                <i class="iconfont iconsousuo1" style="font-size: 24px" @click="goTranslation"></i>
              </Tooltip>
              <Tooltip v-if="connect.from" content="清空" placement="top">
                <i class="iconfont iconguanbi1" @click="clearTranslation"></i>
              </Tooltip>
              <Tooltip v-if="connect.from" content="复制" placement="top">
                <i class="iconfont iconfuzhi" @click="getEdit(connect.from)"></i>
              </Tooltip>
              <Tooltip content="粘贴" placement="top">
                <i class="iconfont iconniantie" @click="getPaste()"></i>
              </Tooltip>
            </p>
            <span>{{ connect.from.length }}/500</span>
          </div>
        </div>
        <div class="grid-content" style="border-left:1px solid #dcdfe6;">
          <div v-if="connect.to_lang=='mn'" class="content_box aqt_lang_mn titlefont" v-html="U2M(tranResult)"></div>
          <div v-else class="content_box" v-html="tranResult"></div>
          <div v-if="tranResult" class="content_copy">
            <Tooltip content="复制" placement="top">
              <i class="iconfont iconfuzhi" @click="getEdit(tranResult)"></i>
            </Tooltip>
          </div>
        </div>
      </div>
      <!--    加载动画-->
      <AqtSpin v-if="isSpin"></AqtSpin>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      connect: {
        from: "",
        from_lang: 'zh',//开始语言
        to_lang: 'mn',//结束语言
        member_id: '',//用户id
        terminal: '',//平台类型：1阿启泰书籍文献APP、2阿启泰优质资源PC端、3阿启泰蒙医药资源库PC、4阿启泰蒙医药资源库APP 5阿启泰互联网书店公众号6图书馆门户网站7统一检索8墨水屏10自己的安卓ipad
      },
      tranResult: '',
      isSpin: false,
      clipboardContent:'',//剪贴内容
    }
  },
  methods: {
    //翻译
    goTranslation() {
      let that = this
      if (!that.connect.to_lang) {
        that.$Message.warning({
          render: h => {
            return h('span', {
              style: {
                writingMode: 'vertical-lr'
              }
            }, '请选择目标语言')
          }
        });
        return
      }
      that.tranResult = ''
      that.isSpin = true
      that.connect.member_id = that.member_id
      that.connect.terminal = that.$terminal
      that.$httpsencrypt.post(`api/web/v3/fanyi/translate`, that.connect)
          .then(val => {
            if (val.code == 200) {
              that.tranResult = val.data.to
            }
            that.isSpin = false
          }).catch(e => {
        that.isSpin = false
      })
    },
    //清除
    clearTranslation() {
      let that = this
      that.connect.from = ''
      that.tranResult = ''
    },
    Hh() {
      let that = this
      let from_lang = JSON.parse(JSON.stringify(that.connect.from_lang))
      let to_lang = JSON.parse(JSON.stringify(that.connect.to_lang))

      setTimeout(function () {
        that.connect.from_lang = to_lang
        that.connect.to_lang = from_lang
      }, 200)

    },
    //限制字符长度
    maxLengthblur(data) {
      let that = this
      let limLength = 500
      if (data.target.value.length > limLength) {
        if (that.connect.from_lang == 'mn') {
          // that.connect.from = that.$getOnBlur(data.target.value.substr(0, limLength))
          that.connect.from = data.target.value.substr(0, limLength)
        } else {
          that.connect.from = data.target.value.substr(0, limLength)
        }
      } else {
        if (that.connect.from_lang == 'mn') {
          // that.connect.from = that.$getOnBlur(data.target.value)
          that.connect.from = data.target.value
        } else {
          that.connect.from = data.target.value
        }
      }
    },

    maxLengthinput(data) {
      let that = this
      let limLength = 500
      if (data.target.value.length > limLength) {
        if (that.connect.from_lang == 'mn') {
          // that.connect.from = that.$getOnBlur(data.target.value.substr(0, limLength))
          that.connect.from = data.target.value.substr(0, limLength)
        } else {
          that.connect.from = data.target.value.substr(0, limLength)
        }
      }
    },
    //点击编辑按钮
    getEdit(value) {
      let that = this
      if (!value) {
        return
      }
      let inputDom = document.createElement('textarea') // js创建一个文本框
      document.body.appendChild(inputDom) //将文本框暂时创建到实例里面
      if (that.connect.from_lang == 'mn') {
        inputDom.value = that.htmlToString(M2Unicode(value)) //将需要复制的内容赋值到创建的文本框中
      } else {
        inputDom.value = that.htmlToString(value) //将需要复制的内容赋值到创建的文本框中
      }
      inputDom.select() //选中文本框中的内容
      inputDom.focus()
      document.execCommand('copy') //执行复制操作
      document.body.removeChild(inputDom) //最后移出
      that.$Message.success({
        render: h => {
          return h('span',{
            style: {
              writingMode: 'vertical-lr'
            }
          },  '文本已复制到剪贴板')
        }
      });
    },
    htmlToString(htmlStr) {
      return htmlStr.replace(/<\/?.+?\/?>|\r|\n/g, ' ')
    },
    //获取语言
    getLang() {
      const _this = this
      let con = {
        type: 'fylanguage',//语言列表，全部传all
      }
      _this.$httpsencrypt.post(`api/web/v3/bookdatadictionary/index`, con)
          .then(val => {
            this.$store.commit('SET_langNewArr', val.data)
            localStorage.removeItem('langNewArr')
            localStorage.setItem('langNewArr', JSON.stringify(val.data))
          }).catch(err => {
      })
    },
    //父组件调用请求数组
    ParentCom(val) {
    },
    //粘贴
    async getPaste() {
      try {
        let clipboardContent = await navigator.clipboard.readText();
        if(clipboardContent){
          this.connect.from = this.connect.from +(this.connect.from?' ':'')+ clipboardContent
          this.$refs.textareaContent.focus()
        }
      } catch (err) {
      }
    }

  },
  created() {
    let that = this
    if (!that.$store.getters.langNewArr.length) {
      that.getLang()
    }

    let info = {
      type: 0,
      path: this.$route.path,
      mark: '智慧翻译',
    }
    this.$store.dispatch('saveUserBehavior', info).then(() => {
    })
  },
  computed: {
    langNewArr: {
      get: function () {
        let ll = this.$store.getters.langNewArr
        this.showlangNewArr = ll
        return ll;
      },
      set: function (newValue) {
        let ll = newValue
        this.showlangNewArr = ll
        return ll;
      },
    },
    member_id() {
      let vv = localStorage.getItem("userInfoMemberId") ? JSON.parse(this.$crypto.get(localStorage.getItem("userInfoMemberId"))).member_id : ''
      return vv
    },
  }
}
</script>

<style lang="less" scoped>
#LayIntarTranslateZh {
  width: 100%;
  height: 100%;
  padding: 15px;

  .LayIntarTranslateZh {
    width: 100%;
    height: 100%;
    border: 1px solid #dcdfe6;
    border-radius: 12.5px;
    background: #ffffff;
    position: relative;

    .transHeader {
      height: 80px;
      border-bottom: 1px solid #eeeeee;
      padding: 0 20px;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .ibox {
        width: 60px;
        height: 80px;
        text-align: center;
        line-height: 80px;

        i {
          cursor: pointer;
          font-size: 20px;
          color: #666666;
        }
      }
    }

    .translation-box {
      width: 100%;
      height: calc(100% - 80px);
      display: flex;

      .grid-content {
        width: 50%;
        height: 100%;

        .translate_box {
          width: 100%;
          height: calc(100% - 50px);
          display: flex;

          .textarea_1_up {
            width: 100%;
            height: 100%;
            display: table-column !important;
            color: #000000;
            padding: 20px;
            resize: none;
            border: none;
            outline: none;
            overflow: auto !important;
            white-space: pre-wrap;
            line-height: 35px;
            font-weight: unset;
            font-weight: normal;
            background: #ffffff;
            font-size: 25px;
            border-radius: 0;
          }

          textarea::placeholder {
            font-size: 25px;
            line-height: 35px;
          }
        }

        .translate_copy {
          width: 100%;
          height: 50px;
          line-height: 50px;
          padding: 0 20px;
          display: flex;
          justify-content: space-between;

          span {
            font-size: 18px;
            color: #888888;
          }

          p {
            width: 150px;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;


            i {
              color: #888888;
              font-size: 30px;
              cursor: pointer;
            }

            i:hover {
              color: var(--themeColor);
            }
          }
        }

        .content_box {
          width: 100%;
          height: calc(100% - 50px);
          padding: 10px;
          font-size: 24px;
          line-height: 35px;
          overflow: auto;
          color: #000000;
          white-space: pre-wrap;
        }

        .content_copy {
          width: 100%;
          height: 50px;
          text-align: right;
          line-height: 50px;
          padding-right: 20px;

          i {
            color: #888888;
            font-size: 28px;
            cursor: pointer;
          }

          i:hover {
            color: var(--themeColor);
          }
        }
      }
    }
  }
}
</style>

<style lang="less">
#LayIntarTranslateZh {
  .el-input__inner {
    background: #f7f7f7 !important;
    border-radius: 8.75px !important;
    border-color: #f7f7f7 !important;
  }

  //.ivu-tooltip {
  //  height: 50px !important;
  //}
  //
  //.ivu-tooltip-popper {
  //  //top: 672px !important;
  //}
  //
  //.ivu-tooltip-inner {
  //  max-height: 250px !important;
  //  max-width: 34px !important;
  //  padding: 12px 8px !important;
  //  text-align: start !important;
  //  font-size: 18px !important;
  //  line-height: 18px !important;
  //
  //  writing-mode: vertical-lr;
  //  text-orientation: sideways-right;
  //  text-orientation: sideways !important;
  //  -o-text-orientation: sideways !important;
  //  -ms-text-orientation: sideways !important;
  //  -moz-text-orientation: sideways !important;
  //  -webkit-text-orientation: sideways !important;
  //  font-family: "MHR8102" !important;
  //}
}

.el-select-dropdown__item.selected {
  color: var(--themeColor) !important;
}
</style>
